import React from "react";

const MaaltijdenPage = () => {
  return <div className="container">Maaltijden</div>;
};

export default MaaltijdenPage;